export const Curve = {
  Secp256k1: 'secp256k1',
  Ed25519: 'ed25519',
  Secp256r1: 'secp256r1',
};
